<template lang="pug">
.company-card.text-black
  NuxtLink.company-card__anchor(:to="{ name: 'companies-id', params: { id: company.url_slug ? company.url_slug : company.id } }")
    VTile(:imgSrc="company.thumbnail || company.profile_image" :title="company.name" :isComingSoon="isComingSoon")
      template(v-slot:toggle)
        BadgeFollowToggle.company-card__toggle(
          v-if="hasToggleIcon"
          :following="isFollowingCompany"
          :company="company"
          @open-login-modal="$emit('open-login-modal', true)"
          @on-follow="$emit('on-follow', company)"
        )

      template(v-slot:subtitle)
        StockDetails(v-if="stock" :stockSymbol="stockSymbol" :stock="stock")

  slot(name="description")
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import type { Company } from '@/entities/company'

const props = defineProps({
  company: {
    required: true,
    type: Object as PropType<Company>,
  },
  isComingSoon: {
    required: false,
    type: Boolean,
    default: false,
  },
  hasToggleIcon: {
    required: false,
    type: Boolean,
    default: true,
  },
  followingCompanies: {
    type: Array as PropType<Company[]>,
    default: () => [],
  },
})

const config = useRuntimeConfig()
const { stock, stockSymbol } = useFormatStock(toRef(props, 'company'))
const isFollowingCompany = computed(() => props.followingCompanies.some(({ id }) => id === props.company.id))
</script>

<style lang="stylus" scoped>
.company-card
  &__anchor
    display: block
    :deep(.vrify-tile)
      margin-bottom: 8px
</style>
